// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.8_webpack-cli@4.10.0_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.8_webpack-cli@4.10.0_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}
::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}
.ri-form-input,.ri-form-textarea,.ri-form-select,.ri-form-multiselect {
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  background-color: #fff;
  border-color: #6b7280;
  border-width: 1px;
  border-radius: 0px;
  padding-top: 0.5rem;
  padding-right: 0.75rem;
  padding-bottom: 0.5rem;
  padding-left: 0.75rem;
  font-size: 1rem;
  line-height: 1.5rem;
  --tw-shadow: 0 0 #0000;
}
.ri-form-input:focus, .ri-form-textarea:focus, .ri-form-select:focus, .ri-form-multiselect:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
  --tw-ring-inset: var(--tw-empty,/*!*/ /*!*/);
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: #2563eb;
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  border-color: #2563eb;
}
.ri-form-input::-moz-placeholder, .ri-form-textarea::-moz-placeholder {
  color: #6b7280;
  opacity: 1;
}
.ri-form-input::placeholder,.ri-form-textarea::placeholder {
  color: #6b7280;
  opacity: 1;
}
.ri-form-input::-webkit-datetime-edit-fields-wrapper {
  padding: 0;
}
.ri-form-input::-webkit-date-and-time-value {
  min-height: 1.5em;
  text-align: inherit;
}
.ri-form-input::-webkit-datetime-edit {
  display: inline-flex;
}
.ri-form-input::-webkit-datetime-edit,.ri-form-input::-webkit-datetime-edit-year-field,.ri-form-input::-webkit-datetime-edit-month-field,.ri-form-input::-webkit-datetime-edit-day-field,.ri-form-input::-webkit-datetime-edit-hour-field,.ri-form-input::-webkit-datetime-edit-minute-field,.ri-form-input::-webkit-datetime-edit-second-field,.ri-form-input::-webkit-datetime-edit-millisecond-field,.ri-form-input::-webkit-datetime-edit-meridiem-field {
  padding-top: 0;
  padding-bottom: 0;
}
.ri-pointer-events-none {
  pointer-events: none !important;
}
.ri-fixed {
  position: fixed !important;
}
.ri-absolute {
  position: absolute !important;
}
.ri-relative {
  position: relative !important;
}
.ri-inset-0 {
  inset: 0px !important;
}
.ri-inset-4 {
  inset: 1rem !important;
}
.ri-inset-5 {
  inset: 1.25rem !important;
}
.ri-inset-8 {
  inset: 2rem !important;
}
.ri-inset-auto {
  inset: auto !important;
}
.ri-inset-x-4 {
  left: 1rem !important;
  right: 1rem !important;
}
.ri-inset-y-1\\/3 {
  top: 33.333333% !important;
  bottom: 33.333333% !important;
}
.ri--top-2 {
  top: -0.5rem !important;
}
.ri-left-0 {
  left: 0px !important;
}
.ri-left-2 {
  left: 0.5rem !important;
}
.ri-right-0 {
  right: 0px !important;
}
.ri-top-0 {
  top: 0px !important;
}
.ri-top-1\\/2 {
  top: 50% !important;
}
.ri-z-0 {
  z-index: 0 !important;
}
.ri-z-10 {
  z-index: 10 !important;
}
.ri-z-20 {
  z-index: 20 !important;
}
.ri-z-2147483647 {
  z-index: 2147483647 !important;
}
.ri-col-span-12 {
  grid-column: span 12 / span 12 !important;
}
.ri-col-span-2 {
  grid-column: span 2 / span 2 !important;
}
.ri-col-span-4 {
  grid-column: span 4 / span 4 !important;
}
.ri-col-span-5 {
  grid-column: span 5 / span 5 !important;
}
.ri-col-start-1 {
  grid-column-start: 1 !important;
}
.ri-m-0 {
  margin: 0px !important;
}
.ri-mx-2 {
  margin-left: 0.5rem !important;
  margin-right: 0.5rem !important;
}
.ri-mx-4 {
  margin-left: 1rem !important;
  margin-right: 1rem !important;
}
.ri-mx-auto {
  margin-left: auto !important;
  margin-right: auto !important;
}
.ri-my-10 {
  margin-top: 2.5rem !important;
  margin-bottom: 2.5rem !important;
}
.ri-my-2 {
  margin-top: 0.5rem !important;
  margin-bottom: 0.5rem !important;
}
.ri-my-3 {
  margin-top: 0.75rem !important;
  margin-bottom: 0.75rem !important;
}
.ri-my-4 {
  margin-top: 1rem !important;
  margin-bottom: 1rem !important;
}
.ri-my-6 {
  margin-top: 1.5rem !important;
  margin-bottom: 1.5rem !important;
}
.ri-my-8 {
  margin-top: 2rem !important;
  margin-bottom: 2rem !important;
}
.ri--ml-px {
  margin-left: -1px !important;
}
.ri-mb-0 {
  margin-bottom: 0px !important;
}
.ri-mb-1 {
  margin-bottom: 0.25rem !important;
}
.ri-mb-10 {
  margin-bottom: 2.5rem !important;
}
.ri-mb-12 {
  margin-bottom: 3rem !important;
}
.ri-mb-2 {
  margin-bottom: 0.5rem !important;
}
.ri-mb-3 {
  margin-bottom: 0.75rem !important;
}
.ri-mb-4 {
  margin-bottom: 1rem !important;
}
.ri-mb-5 {
  margin-bottom: 1.25rem !important;
}
.ri-mb-6 {
  margin-bottom: 1.5rem !important;
}
.ri-mb-8 {
  margin-bottom: 2rem !important;
}
.ri-ml-1 {
  margin-left: 0.25rem !important;
}
.ri-ml-2 {
  margin-left: 0.5rem !important;
}
.ri-mr-10 {
  margin-right: 2.5rem !important;
}
.ri-mr-2 {
  margin-right: 0.5rem !important;
}
.ri-mr-3 {
  margin-right: 0.75rem !important;
}
.ri-mr-4 {
  margin-right: 1rem !important;
}
.ri-mt-0 {
  margin-top: 0px !important;
}
.ri-mt-1 {
  margin-top: 0.25rem !important;
}
.ri-mt-10 {
  margin-top: 2.5rem !important;
}
.ri-mt-2 {
  margin-top: 0.5rem !important;
}
.ri-mt-3 {
  margin-top: 0.75rem !important;
}
.ri-mt-4 {
  margin-top: 1rem !important;
}
.ri-mt-8 {
  margin-top: 2rem !important;
}
.ri-box-border {
  box-sizing: border-box !important;
}
.ri-block {
  display: block !important;
}
.ri-inline-block {
  display: inline-block !important;
}
.ri-inline {
  display: inline !important;
}
.ri-flex {
  display: flex !important;
}
.ri-inline-flex {
  display: inline-flex !important;
}
.ri-grid {
  display: grid !important;
}
.ri-hidden {
  display: none !important;
}
.ri-h-1 {
  height: 0.25rem !important;
}
.ri-h-12 {
  height: 3rem !important;
}
.ri-h-16 {
  height: 4rem !important;
}
.ri-h-24 {
  height: 6rem !important;
}
.ri-h-3 {
  height: 0.75rem !important;
}
.ri-h-3\\/4 {
  height: 75% !important;
}
.ri-h-4 {
  height: 1rem !important;
}
.ri-h-5 {
  height: 1.25rem !important;
}
.ri-h-52 {
  height: 13rem !important;
}
.ri-h-6 {
  height: 1.5rem !important;
}
.ri-h-8 {
  height: 2rem !important;
}
.ri-h-96 {
  height: 24rem !important;
}
.ri-h-\\[100svh\\] {
  height: 100svh !important;
}
.ri-h-\\[155px\\] {
  height: 155px !important;
}
.ri-h-\\[24px\\] {
  height: 24px !important;
}
.ri-h-\\[45px\\] {
  height: 45px !important;
}
.ri-h-\\[55\\%\\] {
  height: 55% !important;
}
.ri-h-full {
  height: 100% !important;
}
.ri-h-screen {
  height: 100vh !important;
}
.ri-max-h-96 {
  max-height: 24rem !important;
}
.ri-min-h-screen {
  min-height: 100vh !important;
}
.ri-w-1\\/2 {
  width: 50% !important;
}
.ri-w-12 {
  width: 3rem !important;
}
.ri-w-16 {
  width: 4rem !important;
}
.ri-w-24 {
  width: 6rem !important;
}
.ri-w-3 {
  width: 0.75rem !important;
}
.ri-w-3\\/4 {
  width: 75% !important;
}
.ri-w-32 {
  width: 8rem !important;
}
.ri-w-36 {
  width: 9rem !important;
}
.ri-w-4 {
  width: 1rem !important;
}
.ri-w-4\\/5 {
  width: 80% !important;
}
.ri-w-5 {
  width: 1.25rem !important;
}
.ri-w-6 {
  width: 1.5rem !important;
}
.ri-w-8 {
  width: 2rem !important;
}
.ri-w-\\[24px\\] {
  width: 24px !important;
}
.ri-w-\\[45px\\] {
  width: 45px !important;
}
.ri-w-auto {
  width: auto !important;
}
.ri-w-full {
  width: 100% !important;
}
.ri-max-w-2xl {
  max-width: 42rem !important;
}
.ri-max-w-lg {
  max-width: 32rem !important;
}
.ri-max-w-md {
  max-width: 28rem !important;
}
.ri-max-w-xl {
  max-width: 36rem !important;
}
.ri-max-w-xs {
  max-width: 20rem !important;
}
.ri-flex-1 {
  flex: 1 1 0% !important;
}
.ri-flex-shrink-0 {
  flex-shrink: 0 !important;
}
.ri-flex-grow {
  flex-grow: 1 !important;
}
.ri-transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
@keyframes ri-spin {
  to {
    transform: rotate(360deg);
  }
}
.ri-animate-spin {
  animation: ri-spin 1s linear infinite !important;
}
.ri-cursor-pointer {
  cursor: pointer !important;
}
.ri-list-inside {
  list-style-position: inside !important;
}
.ri-list-disc {
  list-style-type: disc !important;
}
.ri-appearance-none {
  -webkit-appearance: none !important;
     -moz-appearance: none !important;
          appearance: none !important;
}
.ri-grid-cols-1 {
  grid-template-columns: repeat(1, minmax(0, 1fr)) !important;
}
.ri-grid-cols-12 {
  grid-template-columns: repeat(12, minmax(0, 1fr)) !important;
}
.ri-grid-cols-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
}
.ri-flex-col {
  flex-direction: column !important;
}
.ri-place-items-center {
  place-items: center !important;
}
.ri-items-start {
  align-items: flex-start !important;
}
.ri-items-end {
  align-items: flex-end !important;
}
.ri-items-center {
  align-items: center !important;
}
.ri-items-stretch {
  align-items: stretch !important;
}
.ri-justify-start {
  justify-content: flex-start !important;
}
.ri-justify-end {
  justify-content: flex-end !important;
}
.ri-justify-center {
  justify-content: center !important;
}
.ri-justify-between {
  justify-content: space-between !important;
}
.ri-justify-around {
  justify-content: space-around !important;
}
.ri-gap-1 {
  gap: 0.25rem !important;
}
.ri-gap-2 {
  gap: 0.5rem !important;
}
.ri-gap-3 {
  gap: 0.75rem !important;
}
.ri-gap-4 {
  gap: 1rem !important;
}
.ri-gap-x-3 {
  -moz-column-gap: 0.75rem !important;
       column-gap: 0.75rem !important;
}
.ri-space-y-1 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0 !important;
  margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse))) !important;
  margin-bottom: calc(0.25rem * var(--tw-space-y-reverse)) !important;
}
.ri-overflow-auto {
  overflow: auto !important;
}
.ri-whitespace-pre-wrap {
  white-space: pre-wrap !important;
}
.ri-rounded {
  border-radius: 0.25rem !important;
}
.ri-rounded-full {
  border-radius: 9999px !important;
}
.ri-rounded-lg {
  border-radius: 0.5rem !important;
}
.ri-rounded-md {
  border-radius: 0.375rem !important;
}
.ri-rounded-xl {
  border-radius: 0.75rem !important;
}
.ri-rounded-r-md {
  border-top-right-radius: 0.375rem !important;
  border-bottom-right-radius: 0.375rem !important;
}
.ri-rounded-bl-md {
  border-bottom-left-radius: 0.375rem !important;
}
.ri-rounded-tl-md {
  border-top-left-radius: 0.375rem !important;
}
.ri-border {
  border-width: 1px !important;
}
.ri-border-0 {
  border-width: 0px !important;
}
.ri-border-4 {
  border-width: 4px !important;
}
.ri-border-b {
  border-bottom-width: 1px !important;
}
.ri-border-t {
  border-top-width: 1px !important;
}
.ri-border-solid {
  border-style: solid !important;
}
.ri-border-dashed {
  border-style: dashed !important;
}
.ri-border-gray-100 {
  --tw-border-opacity: 1 !important;
  border-color: rgb(243 244 246 / var(--tw-border-opacity, 1)) !important;
}
.ri-border-gray-200 {
  --tw-border-opacity: 1 !important;
  border-color: rgb(229 231 235 / var(--tw-border-opacity, 1)) !important;
}
.ri-border-gray-300 {
  --tw-border-opacity: 1 !important;
  border-color: rgb(209 213 219 / var(--tw-border-opacity, 1)) !important;
}
.ri-border-gray-400 {
  --tw-border-opacity: 1 !important;
  border-color: rgb(156 163 175 / var(--tw-border-opacity, 1)) !important;
}
.ri-border-gray-500 {
  --tw-border-opacity: 1 !important;
  border-color: rgb(107 114 128 / var(--tw-border-opacity, 1)) !important;
}
.ri-border-red-200 {
  --tw-border-opacity: 1 !important;
  border-color: rgb(254 202 202 / var(--tw-border-opacity, 1)) !important;
}
.ri-border-red-300 {
  --tw-border-opacity: 1 !important;
  border-color: rgb(252 165 165 / var(--tw-border-opacity, 1)) !important;
}
.ri-border-red-500 {
  --tw-border-opacity: 1 !important;
  border-color: rgb(239 68 68 / var(--tw-border-opacity, 1)) !important;
}
.ri-border-white {
  --tw-border-opacity: 1 !important;
  border-color: rgb(255 255 255 / var(--tw-border-opacity, 1)) !important;
}
.ri-bg-gray-100 {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1)) !important;
}
.ri-bg-gray-200 {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity, 1)) !important;
}
.ri-bg-gray-300 {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(209 213 219 / var(--tw-bg-opacity, 1)) !important;
}
.ri-bg-gray-400 {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(156 163 175 / var(--tw-bg-opacity, 1)) !important;
}
.ri-bg-gray-50 {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity, 1)) !important;
}
.ri-bg-green-600 {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(22 163 74 / var(--tw-bg-opacity, 1)) !important;
}
.ri-bg-orange-500 {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(249 115 22 / var(--tw-bg-opacity, 1)) !important;
}
.ri-bg-primary-color {
  background-color: var(--real-id-primaryColor) !important;
}
.ri-bg-red-200 {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(254 202 202 / var(--tw-bg-opacity, 1)) !important;
}
.ri-bg-red-50 {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(254 242 242 / var(--tw-bg-opacity, 1)) !important;
}
.ri-bg-secondary-color {
  background-color: var(--real-id-secondaryColor) !important;
}
.ri-bg-slate-200 {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(226 232 240 / var(--tw-bg-opacity, 1)) !important;
}
.ri-bg-slate-900 {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(15 23 42 / var(--tw-bg-opacity, 1)) !important;
}
.ri-bg-transparent {
  background-color: transparent !important;
}
.ri-bg-white {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1)) !important;
}
.ri-bg-opacity-60 {
  --tw-bg-opacity: 0.6 !important;
}
.ri-stroke-current {
  stroke: currentColor !important;
}
.ri-object-cover {
  -o-object-fit: cover !important;
     object-fit: cover !important;
}
.ri-p-1 {
  padding: 0.25rem !important;
}
.ri-p-2 {
  padding: 0.5rem !important;
}
.ri-p-2\\.5 {
  padding: 0.625rem !important;
}
.ri-p-3 {
  padding: 0.75rem !important;
}
.ri-p-4 {
  padding: 1rem !important;
}
.ri-p-5 {
  padding: 1.25rem !important;
}
.ri-p-6 {
  padding: 1.5rem !important;
}
.ri-p-8 {
  padding: 2rem !important;
}
.ri-px-1 {
  padding-left: 0.25rem !important;
  padding-right: 0.25rem !important;
}
.ri-px-10 {
  padding-left: 2.5rem !important;
  padding-right: 2.5rem !important;
}
.ri-px-2 {
  padding-left: 0.5rem !important;
  padding-right: 0.5rem !important;
}
.ri-px-20 {
  padding-left: 5rem !important;
  padding-right: 5rem !important;
}
.ri-px-3 {
  padding-left: 0.75rem !important;
  padding-right: 0.75rem !important;
}
.ri-px-4 {
  padding-left: 1rem !important;
  padding-right: 1rem !important;
}
.ri-px-5 {
  padding-left: 1.25rem !important;
  padding-right: 1.25rem !important;
}
.ri-px-8 {
  padding-left: 2rem !important;
  padding-right: 2rem !important;
}
.ri-py-1 {
  padding-top: 0.25rem !important;
  padding-bottom: 0.25rem !important;
}
.ri-py-2 {
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
}
.ri-py-20 {
  padding-top: 5rem !important;
  padding-bottom: 5rem !important;
}
.ri-py-3 {
  padding-top: 0.75rem !important;
  padding-bottom: 0.75rem !important;
}
.ri-py-4 {
  padding-top: 1rem !important;
  padding-bottom: 1rem !important;
}
.ri-py-6 {
  padding-top: 1.5rem !important;
  padding-bottom: 1.5rem !important;
}
.ri-py-8 {
  padding-top: 2rem !important;
  padding-bottom: 2rem !important;
}
.ri-pb-12 {
  padding-bottom: 3rem !important;
}
.ri-pb-4 {
  padding-bottom: 1rem !important;
}
.ri-pl-10 {
  padding-left: 2.5rem !important;
}
.ri-pl-5 {
  padding-left: 1.25rem !important;
}
.ri-pr-4 {
  padding-right: 1rem !important;
}
.ri-pt-\\[30\\%\\] {
  padding-top: 30% !important;
}
.ri-pt-\\[40\\%\\] {
  padding-top: 40% !important;
}
.ri-text-left {
  text-align: left !important;
}
.ri-text-center {
  text-align: center !important;
}
.ri-font-sans {
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji" !important;
}
.ri-text-2xl {
  font-size: 1.5em !important;
}
.ri-text-3xl {
  font-size: 1.875em !important;
}
.ri-text-4xl {
  font-size: 2.25em !important;
}
.ri-text-base {
  font-size: 1em !important;
}
.ri-text-lg {
  font-size: 1.125em !important;
}
.ri-text-sm {
  font-size: .875em !important;
}
.ri-text-xl {
  font-size: 1.25em !important;
}
.ri-text-xs {
  font-size: .75em !important;
}
.ri-font-bold {
  font-weight: 700 !important;
}
.ri-font-medium {
  font-weight: 500 !important;
}
.ri-font-semibold {
  font-weight: 600 !important;
}
.ri-uppercase {
  text-transform: uppercase !important;
}
.ri-normal-case {
  text-transform: none !important;
}
.ri-leading-8 {
  line-height: 2rem !important;
}
.ri-leading-normal {
  line-height: 1.5 !important;
}
.ri-leading-relaxed {
  line-height: 1.625 !important;
}
.ri-leading-tight {
  line-height: 1.25 !important;
}
.ri-tracking-normal {
  letter-spacing: 0em !important;
}
.ri-tracking-tight {
  letter-spacing: -0.025em !important;
}
.ri-tracking-widest {
  letter-spacing: 0.1em !important;
}
.ri-text-black {
  --tw-text-opacity: 1 !important;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1)) !important;
}
.ri-text-blue-400 {
  --tw-text-opacity: 1 !important;
  color: rgb(96 165 250 / var(--tw-text-opacity, 1)) !important;
}
.ri-text-blue-600 {
  --tw-text-opacity: 1 !important;
  color: rgb(37 99 235 / var(--tw-text-opacity, 1)) !important;
}
.ri-text-button-text-color {
  color: var(--real-id-buttonTextColor) !important;
}
.ri-text-gray-100 {
  --tw-text-opacity: 1 !important;
  color: rgb(243 244 246 / var(--tw-text-opacity, 1)) !important;
}
.ri-text-gray-400 {
  --tw-text-opacity: 1 !important;
  color: rgb(156 163 175 / var(--tw-text-opacity, 1)) !important;
}
.ri-text-gray-500 {
  --tw-text-opacity: 1 !important;
  color: rgb(107 114 128 / var(--tw-text-opacity, 1)) !important;
}
.ri-text-gray-600 {
  --tw-text-opacity: 1 !important;
  color: rgb(75 85 99 / var(--tw-text-opacity, 1)) !important;
}
.ri-text-gray-700 {
  --tw-text-opacity: 1 !important;
  color: rgb(55 65 81 / var(--tw-text-opacity, 1)) !important;
}
.ri-text-gray-800 {
  --tw-text-opacity: 1 !important;
  color: rgb(31 41 55 / var(--tw-text-opacity, 1)) !important;
}
.ri-text-gray-900 {
  --tw-text-opacity: 1 !important;
  color: rgb(17 24 39 / var(--tw-text-opacity, 1)) !important;
}
.ri-text-green-600 {
  --tw-text-opacity: 1 !important;
  color: rgb(22 163 74 / var(--tw-text-opacity, 1)) !important;
}
.ri-text-primary-color {
  color: var(--real-id-primaryColor) !important;
}
.ri-text-red-500 {
  --tw-text-opacity: 1 !important;
  color: rgb(239 68 68 / var(--tw-text-opacity, 1)) !important;
}
.ri-text-red-600 {
  --tw-text-opacity: 1 !important;
  color: rgb(220 38 38 / var(--tw-text-opacity, 1)) !important;
}
.ri-text-red-700 {
  --tw-text-opacity: 1 !important;
  color: rgb(185 28 28 / var(--tw-text-opacity, 1)) !important;
}
.ri-text-red-800 {
  --tw-text-opacity: 1 !important;
  color: rgb(153 27 27 / var(--tw-text-opacity, 1)) !important;
}
.ri-text-rose-500 {
  --tw-text-opacity: 1 !important;
  color: rgb(244 63 94 / var(--tw-text-opacity, 1)) !important;
}
.ri-text-secondary-color {
  color: var(--real-id-secondaryColor) !important;
}
.ri-text-slate-500 {
  --tw-text-opacity: 1 !important;
  color: rgb(100 116 139 / var(--tw-text-opacity, 1)) !important;
}
.ri-text-slate-600 {
  --tw-text-opacity: 1 !important;
  color: rgb(71 85 105 / var(--tw-text-opacity, 1)) !important;
}
.ri-text-slate-700 {
  --tw-text-opacity: 1 !important;
  color: rgb(51 65 85 / var(--tw-text-opacity, 1)) !important;
}
.ri-text-slate-800 {
  --tw-text-opacity: 1 !important;
  color: rgb(30 41 59 / var(--tw-text-opacity, 1)) !important;
}
.ri-text-white {
  --tw-text-opacity: 1 !important;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1)) !important;
}
.ri-text-yellow-600 {
  --tw-text-opacity: 1 !important;
  color: rgb(202 138 4 / var(--tw-text-opacity, 1)) !important;
}
.ri-underline {
  text-decoration-line: underline !important;
}
.ri-no-underline {
  text-decoration-line: none !important;
}
.ri-opacity-25 {
  opacity: 0.25 !important;
}
.ri-opacity-75 {
  opacity: 0.75 !important;
}
.ri-shadow {
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1) !important;
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color) !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.ri-shadow-sm {
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05) !important;
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color) !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.ri-outline-none {
  outline: 2px solid transparent !important;
  outline-offset: 2px !important;
}
.ri-ring-1 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color) !important;
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color) !important;
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000) !important;
}
.ri-ring-inset {
  --tw-ring-inset: inset !important;
}
.ri-ring-gray-300 {
  --tw-ring-opacity: 1 !important;
  --tw-ring-color: rgb(209 213 219 / var(--tw-ring-opacity, 1)) !important;
}
.ri-ring-green-500 {
  --tw-ring-opacity: 1 !important;
  --tw-ring-color: rgb(34 197 94 / var(--tw-ring-opacity, 1)) !important;
}
.ri-transition-colors {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke !important;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
  transition-duration: 150ms !important;
}

body {
  margin: 0;
}

#real-id-flow {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen",
    "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue",
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

#real-id-flow code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New",
    monospace;
}

#real-id-flow {
  width: 100%;
}

/* vouched wizard customizations */
.vouched .progress-content {
  margin-top: 250px;
}

/* headliner effect */
.liner {
  display: flex;
  align-items: center;
  text-align: center;
}

.liner::after {
  content: "";
  flex-grow: 1;
  height: 1px;
  background: rgb(106, 114, 128);
  min-width: 20px;
  margin: auto;
}

.liner::before {
  content: "";
  flex-grow: 1;
  height: 1px;
  background: rgb(106, 114, 128);
  min-width: 20px;
  margin: auto;
  margin-right: 20px;
}

.liner::after {
  margin-left: 20px;
}

.vouched .navigation {
  display: none;
}

.vouched {
  max-height: 100vh;
}

#vouched-element {
  width: 100%;
}

/** "double" spinner fix" **/
.progress-content.theme-color {
  width: 100px;
}

/**
* Attempting to fix reports of pause/play controls appearing in iOS with Chrome
* https://github.com/mozmorris/react-webcam/issues/338#issuecomment-1279288141
*/
.real-id-webcam-video {
  pointer-events: none;
}

.real-id-webcam-video video::-webkit-media-controls-panel {
  display: none !important;
  -webkit-appearance: none;
}

.real-id-webcam-video video::-webkit-media-controls-play-button {
  display: none !important;
  -webkit-appearance: none;
}

.real-id-webcam-video video::-webkit-media-controls-start-playback-button {
  display: none !important;
  -webkit-appearance: none;
}

.placeholder\\:ri-text-gray-400::-moz-placeholder {
  --tw-text-opacity: 1 !important;
  color: rgb(156 163 175 / var(--tw-text-opacity, 1)) !important;
}

.placeholder\\:ri-text-gray-400::placeholder {
  --tw-text-opacity: 1 !important;
  color: rgb(156 163 175 / var(--tw-text-opacity, 1)) !important;
}

.focus-within\\:ri-z-10:focus-within {
  z-index: 10 !important;
}

.hover\\:ri-bg-green-700:hover {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(21 128 61 / var(--tw-bg-opacity, 1)) !important;
}

.hover\\:ri-text-blue-800:hover {
  --tw-text-opacity: 1 !important;
  color: rgb(30 64 175 / var(--tw-text-opacity, 1)) !important;
}

.hover\\:ri-text-red-800:hover {
  --tw-text-opacity: 1 !important;
  color: rgb(153 27 27 / var(--tw-text-opacity, 1)) !important;
}

.hover\\:ri-text-slate-800:hover {
  --tw-text-opacity: 1 !important;
  color: rgb(30 41 59 / var(--tw-text-opacity, 1)) !important;
}

.hover\\:ri-shadow-lg:hover {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1) !important;
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color) !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}

.focus\\:ri-border-blue-500:focus {
  --tw-border-opacity: 1 !important;
  border-color: rgb(59 130 246 / var(--tw-border-opacity, 1)) !important;
}

.focus\\:ri-ring-2:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color) !important;
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color) !important;
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000) !important;
}

.focus\\:ri-ring-inset:focus {
  --tw-ring-inset: inset !important;
}

.focus\\:ri-ring-blue-500:focus {
  --tw-ring-opacity: 1 !important;
  --tw-ring-color: rgb(59 130 246 / var(--tw-ring-opacity, 1)) !important;
}

.focus\\:ri-ring-indigo-600:focus {
  --tw-ring-opacity: 1 !important;
  --tw-ring-color: rgb(79 70 229 / var(--tw-ring-opacity, 1)) !important;
}

@media (min-width: 475px) {
  .xs\\:ri-mb-12 {
    margin-bottom: 3rem !important;
  }
  .xs\\:ri-mb-2 {
    margin-bottom: 0.5rem !important;
  }
  .xs\\:ri-mb-3 {
    margin-bottom: 0.75rem !important;
  }
  .xs\\:ri-mb-4 {
    margin-bottom: 1rem !important;
  }
  .xs\\:ri-h-2 {
    height: 0.5rem !important;
  }
}

@media (min-width: 640px) {
  .sm\\:ri-inset-10 {
    inset: 2.5rem !important;
  }
  .sm\\:ri-inset-x-24 {
    left: 6rem !important;
    right: 6rem !important;
  }
  .sm\\:ri-right-2 {
    right: 0.5rem !important;
  }
  .sm\\:ri-leading-6 {
    line-height: 1.5rem !important;
  }
}

@media (min-width: 768px) {
  .md\\:ri-static {
    position: static !important;
  }
  .md\\:ri-inset-auto {
    inset: auto !important;
  }
  .md\\:ri-inset-x-24 {
    left: 6rem !important;
    right: 6rem !important;
  }
  .md\\:ri-inset-x-36 {
    left: 9rem !important;
    right: 9rem !important;
  }
  .md\\:ri-inset-y-1\\/4 {
    top: 25% !important;
    bottom: 25% !important;
  }
  .md\\:ri-inset-y-12 {
    top: 3rem !important;
    bottom: 3rem !important;
  }
  .md\\:ri-right-4 {
    right: 1rem !important;
  }
  .md\\:ri-z-0 {
    z-index: 0 !important;
  }
  .md\\:ri-col-span-6 {
    grid-column: span 6 / span 6 !important;
  }
  .md\\:ri-col-start-4 {
    grid-column-start: 4 !important;
  }
  .md\\:ri-mb-16 {
    margin-bottom: 4rem !important;
  }
  .md\\:ri-mb-4 {
    margin-bottom: 1rem !important;
  }
  .md\\:ri-mt-16 {
    margin-top: 4rem !important;
  }
  .md\\:ri-flex {
    display: flex !important;
  }
  .md\\:ri-hidden {
    display: none !important;
  }
  .md\\:ri-h-full {
    height: 100% !important;
  }
  .md\\:ri-w-44 {
    width: 11rem !important;
  }
  .md\\:ri-w-5\\/12 {
    width: 41.666667% !important;
  }
  .md\\:ri-place-items-start {
    place-items: start !important;
  }
  .md\\:ri-rounded-lg {
    border-radius: 0.5rem !important;
  }
  .md\\:ri-rounded-t {
    border-top-left-radius: 0.25rem !important;
    border-top-right-radius: 0.25rem !important;
  }
  .md\\:ri-bg-auto {
    background-size: auto !important;
  }
  .md\\:ri-px-16 {
    padding-left: 4rem !important;
    padding-right: 4rem !important;
  }
  .md\\:ri-text-3xl {
    font-size: 1.875em !important;
  }
  .md\\:ri-text-base {
    font-size: 1em !important;
  }
  .md\\:ri-shadow {
    --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1) !important;
    --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color) !important;
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
  }
}

@media (min-width: 1024px) {
  .lg\\:ri-inset-x-56 {
    left: 14rem !important;
    right: 14rem !important;
  }
  .lg\\:ri-mb-20 {
    margin-bottom: 5rem !important;
  }
  .lg\\:ri-shadow-none {
    --tw-shadow: 0 0 #0000 !important;
    --tw-shadow-colored: 0 0 #0000 !important;
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
  }
}

@media (min-width: 1280px) {
  .xl\\:ri-inset-x-80 {
    left: 20rem !important;
    right: 20rem !important;
  }
  .xl\\:ri-block {
    display: block !important;
  }
}

@media (orientation: portrait) {
  .portrait\\:ri-inset-y-52 {
    top: 13rem !important;
    bottom: 13rem !important;
  }
  .portrait\\:ri-inset-y-\\[30\\%\\] {
    top: 30% !important;
    bottom: 30% !important;
  }
  .portrait\\:ri-bottom-24 {
    bottom: 6rem !important;
  }
  .portrait\\:ri-flex {
    display: flex !important;
  }
  .portrait\\:ri-h-full {
    height: 100% !important;
  }
  .portrait\\:ri-flex-col {
    flex-direction: column !important;
  }
  .portrait\\:ri-justify-center {
    justify-content: center !important;
  }
  .portrait\\:ri-pt-\\[20\\%\\] {
    padding-top: 20% !important;
  }
  .portrait\\:ri-pt-\\[60\\%\\] {
    padding-top: 60% !important;
  }
}

@media (min-width: 475px) {
  @media (orientation: portrait) {
    .xs\\:portrait\\:ri-inset-y-1\\/4 {
      top: 25% !important;
      bottom: 25% !important;
    }
  }
}

@media (orientation: portrait) {
  @media (min-width: 640px) {
    .portrait\\:sm\\:ri-inset-y-\\[20\\%\\] {
      top: 20% !important;
      bottom: 20% !important;
    }
  }
}

@media (min-width: 640px) {
  @media (orientation: portrait) {
    .sm\\:portrait\\:ri-block {
      display: block !important;
    }
    .sm\\:portrait\\:ri-hidden {
      display: none !important;
    }
  }
}

@media (orientation: landscape) {
  .landscape\\:ri-absolute {
    position: absolute !important;
  }
  .landscape\\:ri-inset-0 {
    inset: 0px !important;
  }
  .landscape\\:ri-bottom-0 {
    bottom: 0px !important;
  }
  .landscape\\:ri-right-6 {
    right: 1.5rem !important;
  }
  .landscape\\:ri-flex {
    display: flex !important;
  }
  .landscape\\:ri-hidden {
    display: none !important;
  }
  .landscape\\:ri-flex-col {
    flex-direction: column !important;
  }
}

@media (min-width: 475px) {
  @media (orientation: landscape) {
    .xs\\:landscape\\:ri-inset-y-12 {
      top: 3rem !important;
      bottom: 3rem !important;
    }
  }
}

@media (min-width: 640px) {
  @media (orientation: landscape) {
    .sm\\:landscape\\:ri-inset-y-24 {
      top: 6rem !important;
      bottom: 6rem !important;
    }
  }
}

@media (orientation: landscape) {
  @media (min-width: 640px) {
    .landscape\\:sm\\:ri-bottom-4 {
      bottom: 1rem !important;
    }
  }
}

@media (min-width: 768px) {
  @media (orientation: landscape) {
    .md\\:landscape\\:ri-static {
      position: static !important;
    }
    .md\\:landscape\\:ri-inset-auto {
      inset: auto !important;
    }
    .md\\:landscape\\:ri-inset-y-\\[20\\%\\] {
      top: 20% !important;
      bottom: 20% !important;
    }
  }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;AACd;EAAA,wBAAoB;KAApB,qBAAoB;UAApB,gBAAoB;EAApB,sBAAoB;EAApB,qBAAoB;EAApB,iBAAoB;EAApB,kBAAoB;EAApB,mBAAoB;EAApB,sBAAoB;EAApB,sBAAoB;EAApB,qBAAoB;EAApB,eAAoB;EAApB,mBAAoB;EAApB,sBAAoB;AAAA;AAApB;EAAA,8BAAoB;EAApB,mBAAoB;EAApB,4CAAoB;EAApB,2BAAoB;EAApB,4BAAoB;EAApB,wBAAoB;EAApB,2GAAoB;EAApB,yGAAoB;EAApB,iFAAoB;EAApB;AAAoB;AAApB;EAAA,cAAoB;EAApB;AAAoB;AAApB;EAAA,cAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,iBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,cAAoB;EAApB;AAAoB;AACpB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,mCAAmB;KAAnB,gCAAmB;UAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,mCAAmB;OAAnB;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB,0EAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,4CAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,+BAAmB;KAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qFAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,qDAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB;AAAmB;AAAnB;EAAA,sHAAmB;EAAnB,oHAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,0GAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;;AAEnB;EACE,SAAS;AACX;;AAEA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE;aACW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA,kCAAkC;AAClC;EACE,iBAAiB;AACnB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,WAAW;EACX,8BAA8B;EAC9B,eAAe;EACf,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,WAAW;EACX,8BAA8B;EAC9B,eAAe;EACf,YAAY;EAIZ,kBAAkB;AAHpB;;AAMA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA,4BAA4B;AAC5B;EACE,YAAY;AACd;;AAEA;;;CAGC;AACD;EACE,oBAAoB;AACtB;;AAEA;EACE,wBAAwB;EACxB,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;EACxB,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;EACxB,wBAAwB;AAC1B;;AAtGA;EAAA,+BAuGA;EAvGA;AAuGA;;AAvGA;EAAA,+BAuGA;EAvGA;AAuGA;;AAvGA;EAAA;AAuGA;;AAvGA;EAAA,6BAuGA;EAvGA;AAuGA;;AAvGA;EAAA,+BAuGA;EAvGA;AAuGA;;AAvGA;EAAA,+BAuGA;EAvGA;AAuGA;;AAvGA;EAAA,+BAuGA;EAvGA;AAuGA;;AAvGA;EAAA,0FAuGA;EAvGA,8GAuGA;EAvGA;AAuGA;;AAvGA;EAAA,iCAuGA;EAvGA;AAuGA;;AAvGA;EAAA,sHAuGA;EAvGA,oHAuGA;EAvGA;AAuGA;;AAvGA;EAAA;AAuGA;;AAvGA;EAAA,+BAuGA;EAvGA;AAuGA;;AAvGA;EAAA,+BAuGA;EAvGA;AAuGA;;AAvGA;EAAA;IAAA;EAuGA;EAvGA;IAAA;EAuGA;EAvGA;IAAA;EAuGA;EAvGA;IAAA;EAuGA;EAvGA;IAAA;EAuGA;AAAA;;AAvGA;EAAA;IAAA;EAuGA;EAvGA;IAAA,qBAuGA;IAvGA;EAuGA;EAvGA;IAAA;EAuGA;EAvGA;IAAA;EAuGA;AAAA;;AAvGA;EAAA;IAAA;EAuGA;EAvGA;IAAA;EAuGA;EAvGA;IAAA,qBAuGA;IAvGA;EAuGA;EAvGA;IAAA,qBAuGA;IAvGA;EAuGA;EAvGA;IAAA,mBAuGA;IAvGA;EAuGA;EAvGA;IAAA,oBAuGA;IAvGA;EAuGA;EAvGA;IAAA;EAuGA;EAvGA;IAAA;EAuGA;EAvGA;IAAA;EAuGA;EAvGA;IAAA;EAuGA;EAvGA;IAAA;EAuGA;EAvGA;IAAA;EAuGA;EAvGA;IAAA;EAuGA;EAvGA;IAAA;EAuGA;EAvGA;IAAA;EAuGA;EAvGA;IAAA;EAuGA;EAvGA;IAAA;EAuGA;EAvGA;IAAA;EAuGA;EAvGA;IAAA;EAuGA;EAvGA;IAAA;EAuGA;EAvGA;IAAA,0CAuGA;IAvGA;EAuGA;EAvGA;IAAA;EAuGA;EAvGA;IAAA,6BAuGA;IAvGA;EAuGA;EAvGA;IAAA;EAuGA;EAvGA;IAAA;EAuGA;EAvGA;IAAA,qFAuGA;IAvGA,yGAuGA;IAvGA;EAuGA;AAAA;;AAvGA;EAAA;IAAA,sBAuGA;IAvGA;EAuGA;EAvGA;IAAA;EAuGA;EAvGA;IAAA,iCAuGA;IAvGA,yCAuGA;IAvGA;EAuGA;AAAA;;AAvGA;EAAA;IAAA,sBAuGA;IAvGA;EAuGA;EAvGA;IAAA;EAuGA;AAAA;;AAvGA;EAAA;IAAA,qBAuGA;IAvGA;EAuGA;EAvGA;IAAA,mBAuGA;IAvGA;EAuGA;EAvGA;IAAA;EAuGA;EAvGA;IAAA;EAuGA;EAvGA;IAAA;EAuGA;EAvGA;IAAA;EAuGA;EAvGA;IAAA;EAuGA;EAvGA;IAAA;EAuGA;EAvGA;IAAA;EAuGA;AAAA;;AAvGA;EAAA;IAAA;MAAA,mBAuGA;MAvGA;IAuGA;EAAA;AAAA;;AAvGA;EAAA;IAAA;MAAA,mBAuGA;MAvGA;IAuGA;EAAA;AAAA;;AAvGA;EAAA;IAAA;MAAA;IAuGA;IAvGA;MAAA;IAuGA;EAAA;AAAA;;AAvGA;EAAA;IAAA;EAuGA;EAvGA;IAAA;EAuGA;EAvGA;IAAA;EAuGA;EAvGA;IAAA;EAuGA;EAvGA;IAAA;EAuGA;EAvGA;IAAA;EAuGA;EAvGA;IAAA;EAuGA;AAAA;;AAvGA;EAAA;IAAA;MAAA,oBAuGA;MAvGA;IAuGA;EAAA;AAAA;;AAvGA;EAAA;IAAA;MAAA,oBAuGA;MAvGA;IAuGA;EAAA;AAAA;;AAvGA;EAAA;IAAA;MAAA;IAuGA;EAAA;AAAA;;AAvGA;EAAA;IAAA;MAAA;IAuGA;IAvGA;MAAA;IAuGA;IAvGA;MAAA,mBAuGA;MAvGA;IAuGA;EAAA;AAAA","sourcesContent":["@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\nbody {\n  margin: 0;\n}\n\n#real-id-flow {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\",\n    \"Ubuntu\", \"Cantarell\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\",\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n#real-id-flow code {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, \"Courier New\",\n    monospace;\n}\n\n#real-id-flow {\n  width: 100%;\n}\n\n/* vouched wizard customizations */\n.vouched .progress-content {\n  margin-top: 250px;\n}\n\n/* headliner effect */\n.liner {\n  display: flex;\n  align-items: center;\n  text-align: center;\n}\n\n.liner::after {\n  content: \"\";\n  flex-grow: 1;\n  height: 1px;\n  background: rgb(106, 114, 128);\n  min-width: 20px;\n  margin: auto;\n}\n\n.liner::before {\n  content: \"\";\n  flex-grow: 1;\n  height: 1px;\n  background: rgb(106, 114, 128);\n  min-width: 20px;\n  margin: auto;\n}\n\n.liner::before {\n  margin-right: 20px;\n}\n\n.liner::after {\n  margin-left: 20px;\n}\n\n.vouched .navigation {\n  display: none;\n}\n\n.vouched {\n  max-height: 100vh;\n}\n\n#vouched-element {\n  width: 100%;\n}\n\n/** \"double\" spinner fix\" **/\n.progress-content.theme-color {\n  width: 100px;\n}\n\n/**\n* Attempting to fix reports of pause/play controls appearing in iOS with Chrome\n* https://github.com/mozmorris/react-webcam/issues/338#issuecomment-1279288141\n*/\n.real-id-webcam-video {\n  pointer-events: none;\n}\n\n.real-id-webcam-video video::-webkit-media-controls-panel {\n  display: none !important;\n  -webkit-appearance: none;\n}\n\n.real-id-webcam-video video::-webkit-media-controls-play-button {\n  display: none !important;\n  -webkit-appearance: none;\n}\n\n.real-id-webcam-video video::-webkit-media-controls-start-playback-button {\n  display: none !important;\n  -webkit-appearance: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
